import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../api";

const CapabilitiesContext = createContext({ capabilities: null, capabilitiesLoaded: false });

export const canAccessSiteOperations = (capabilities) => Boolean(
  capabilities?.is_admin || capabilities?.permissions?.includes("catalog_edit")
);

export function CapabilitiesProvider({ user, authReady, children }) {
  const userId = user?.id ?? user?.user_id ?? null;
  const [capabilities, setCapabilities] = useState(null);
  const [capabilitiesLoaded, setCapabilitiesLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!authReady) return () => { cancelled = true; };
    if (!userId) {
      setCapabilities(null);
      setCapabilitiesLoaded(true);
      return () => { cancelled = true; };
    }

    setCapabilities(null);
    setCapabilitiesLoaded(false);
    api.get("/api/me/capabilities")
      .then(({ data }) => {
        if (!cancelled) setCapabilities(data?.ok === false ? null : data);
      })
      .catch(() => {
        if (!cancelled) setCapabilities(null);
      })
      .finally(() => {
        if (!cancelled) setCapabilitiesLoaded(true);
      });
    return () => { cancelled = true; };
  }, [authReady, userId]);

  const value = useMemo(
    () => ({ capabilities, capabilitiesLoaded }),
    [capabilities, capabilitiesLoaded]
  );
  return <CapabilitiesContext.Provider value={value}>{children}</CapabilitiesContext.Provider>;
}

export const useCapabilities = () => useContext(CapabilitiesContext);
